import * as React from 'react';
import styled from 'styled-components';
import * as P from 'polished';

import { semibold, connectFont } from '../../serviceTheme';
import * as Icon from '../../icons';
import { withConfig } from '../utils';

import { BtnStyleConfig, Btn } from './shared';


// -------------------------------------------------------------------------------------
//  Normal
// -------------------------------------------------------------------------------------

const configStyleNormal: BtnStyleConfig = {
    colorNormal: () => '#5F5F5F',
    borderColorNormal: () => '#D7D9DE',
    backgroundColorNormal: () => '#fff',

    colorHover: () => '#5F5F5F',
    borderColorHover: () => '#5F5F5F',
    backgroundColorHover: () => '#fff',

    colorActive: () => '#5F5F5F',
    borderColorActive: () => '#5F5F5F',
    backgroundColorActive: () => '#E7E7E7',

    colorDisabled: () => P.lighten(0.3, '#5F5F5F'),
    borderColorDisabled: () => P.lighten(0.3, '#5F5F5F'),
    backgroundColorDisabled: () => '#fff',

    outlineColorFocus: () => 'red',

    font: connectFont(semibold),
}

export const Normal = withConfig<any, HTMLButtonElement>()(configStyleNormal)(Btn);



// -------------------------------------------------------------------------------------
//  Primary
// -------------------------------------------------------------------------------------

const configStylePrimary: BtnStyleConfig = {
    colorNormal: () => '#fff',
    borderColorNormal: () => 'transparent',
    backgroundColorNormal: () => '#2E828B',

    colorHover: () => '#fff',
    borderColorHover: () => 'transparent',
    backgroundColorHover: () => '#2E828B',

    colorActive: () => '#fff',
    borderColorActive: () => 'transparent',
    backgroundColorActive: () => '#114B51',

    colorDisabled: () => P.lighten(0.5, '#000'),
    borderColorDisabled: () => 'transparent',
    backgroundColorDisabled: () => '#D9D9D9',

    outlineColorFocus: () => 'red',

    font: connectFont(semibold),
}


const Primary_ = withConfig<any, HTMLButtonElement>()(configStylePrimary)(Btn);

export const Primary = styled(Primary_)`
    &:not(:disabled):hover {
        box-shadow: 0px 4px 17px rgba(46, 130, 139, 0.4);
    }
`;


// -------------------------------------------------------------------------------------
//  Ghost
// -------------------------------------------------------------------------------------

const configStyleGhost: BtnStyleConfig = {
    colorNormal: () => '#5F5F5F',
    borderColorNormal: () => 'transparent',
    backgroundColorNormal: () => 'transparent',

    colorHover: () => '#5F5F5F',
    borderColorHover: () => 'transparent',
    backgroundColorHover: () => '#F2F2F2',

    colorActive: () => '#5F5F5F',
    borderColorActive: () => 'transparent',
    backgroundColorActive: () => '#E4E4E4',

    colorDisabled: () => P.lighten(0.5, '#000'),
    borderColorDisabled: () => 'transparent',
    backgroundColorDisabled: () => 'transparent',

    outlineColorFocus: () => 'red',

    font: connectFont(semibold),
}

const Ghost_ = withConfig<any, HTMLButtonElement>()(configStyleGhost)(Btn);

export const Ghost = styled(Ghost_)`
    &:disabled {
        text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
`;



// -------------------------------------------------------------------------------------
//  Close
// -------------------------------------------------------------------------------------

const CancelS = styled.button`
`;

export const Close: React.FunctionComponent<React.HTMLAttributes<HTMLButtonElement>> = (props) => {
    return (
        <CancelS {...props}>
            <Icon.Close />
        </CancelS>
    );
}



// -------------------------------------------------------------------------------------
//  Iconed
// -------------------------------------------------------------------------------------


interface IconedProps {
    icon: keyof typeof Icon
}

const IconedS = styled.button`
    border-radius: 4px;
    border: 1px solid #b5b1c4;
    display: flex;
    align-items: center;
    color: #7D7891;
    transition: all .33s ease-in-out;
    padding: 0.422em .5em;

    &:not(:active):hover {
        box-shadow: 0px 4px 17px rgba(173, 173, 173, 0.4);
    }

    &:active {
        background-color: #ccd1e0;
        transition: none;
    }
`;

const IconWrapper = styled.span`
    border-radius: 50%;
    background-color: #7D7891;
    width: 1.3em;
    height: 1.3em;
    position: relative;
    margin-right: 9px;

    & > svg {
        fill: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50%;
        height: 50%;
    }
`;

export const Iconed: React.FunctionComponent<IconedProps & React.HTMLAttributes<HTMLButtonElement>> = 
    ({ children, icon, ...props }) => {

        const Ic = Icon[icon];

        return (
            <IconedS {...props}>
                <IconWrapper>
                    <Ic />
                </IconWrapper>
                {children}
            </IconedS>
        );
    }
